exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flex-none[data-v-7738a392] {\nflex: unset!important;\n}\n", ""]);

// exports
